
/**
 * Module dependencies.
 */

import { useEffect } from 'react';

/**
 * `Props` type.
 */

type Props = {
  off: boolean
};

/**
 * `useBodyScroll` hook.
 */

function useBodyScroll({ off }: Props) {
  useEffect(() => {
    const body = document.body;

    if (!body || !off) {
      return;
    }

    body.style.overflow = 'hidden';

    return () => {
      body.style.overflow = '';
    };
  }, [off]);
}

/**
 * Export `useBodyScroll` hook.
 */

export default useBodyScroll;
